module.exports = __webpack_public_path__ + "img/header2.33415a83.png";